import React, { useMemo } from 'react';

import { Box, Flex } from '@adsk/alloy-react-box';
import HighlightText from '@adsk/alloy-react-highlight-text';
import { DocumentEmptyIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import Tooltip, { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import MalwareTooltipCell from './MalwareTooltipCell';
import { isMalwareDetected } from '../helpers/utils';

const CustomTooltipDocumentNameCell = ({
  rowData,
  disabledIds,
  rowIndicator,
}) => {
  const disabled = disabledIds.includes(rowData.id);
  const { tooltipProps } = rowData;
  const showMalwareIndicator = useMemo(
    () => isMalwareDetected(rowData),
    [rowData],
  );

  return (
    <Box
      data-testid="CustomTooltipDocumentNameCell__content"
      display="inline-flex"
    >
      {!rowData.folderType ? (
        <DocumentEmptyIcon
          style={{
            flex: 'none',
            marginRight: '8px',
            color: disabled && theme.colors.charcoal500,
          }}
        />
      ) : (
        <span style={{ color: disabled && theme.colors.charcoal500 }}>
          {rowData.entityIcon}
        </span>
      )}
      <Flex flexDirection="column" justifyContent="center">
        {showMalwareIndicator ? (
          <MalwareTooltipCell
            rowData={rowData}
            disabled={disabled}
            placement={tooltipProps.placement}
          />
        ) : rowData.tooltipContent ? (
          <Tooltip
            content={rowData.tooltipContent}
            placement={tooltipProps.placement}
            data-testid="CustomTooltipDocumentNameCell__disabled-tooltip"
          >
            <HighlightText
              matched={rowData.highlight}
              text={rowData.title}
              style={{ color: theme.colors.charcoal500 }}
            />
          </Tooltip>
        ) : (
          <OverflowTooltip
            autoTipOnEllipsis
            singleLine
            content={tooltipProps.text}
            style={{ maxWidth: '400px', wordBreak: 'break-word' }}
            placement={tooltipProps.placement}
          >
            <HighlightText
              matched={rowData.highlight}
              text={rowData.title}
              style={{
                color: disabled && theme.colors.charcoal500,
              }}
            />
          </OverflowTooltip>
        )}
        {!!rowData.displayPath && (
          <Box marginTop="6px" overflow="hidden" color="charcoal500">
            {rowData.displayPath}
          </Box>
        )}
      </Flex>
      {rowIndicator}
    </Box>
  );
};

export default CustomTooltipDocumentNameCell;
